/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At least 16 characters for most accounts, using a mix of uppercase, lowercase, numbers and symbols. That gives over 100 bits of entropy, well beyond brute-force reach. For especially sensitive accounts (email, banking, your password manager itself), go to 20 or more.`)
};

const es_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al menos 16 caracteres para la mayoría de cuentas, usando una mezcla de mayúsculas, minúsculas, números y símbolos. Eso proporciona más de 100 bits de entropía, bien más allá del alcance de fuerza bruta. Para cuentas especialmente sensibles (correo electrónico, banca, tu gestor de contraseñas mismo), sube a 20 o más.`)
};

const de_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestens 16 Zeichen für die meisten Konten, mit einer Mischung aus Großbuchstaben, Kleinbuchstaben, Zahlen und Symbolen. Das ergibt über 100 Bits Entropie, weit jenseits der Brute-Force-Reichweite. Für besonders sensible Konten (E-Mail, Banking, Ihr Passwort-Manager selbst) nutzen Sie 20 oder mehr.`)
};

const nl_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minstens 16 tekens voor de meeste accounts, gebruikmakend van een mix van hoofdletters, kleine letters, getallen en symbolen. Dat geeft meer dan 100 bits entropie, ver buiten brute-force bereik. Voor bijzonder gevoelige accounts (e-mail, bankwezen, je eigen wachtwoordmanager), ga naar 20 of meer.`)
};

const fr_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au moins 16 caractères pour la plupart des comptes, en utilisant un mélange de majuscules, minuscules, chiffres et symboles. Cela donne plus de 100 bits d'entropie, bien au-delà de la portée par force brute. Pour les comptes particulièrement sensibles (e-mail, services bancaires, votre gestionnaire de mots de passe lui-même), allez jusqu'à 20 ou plus.`)
};

const it_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almeno 16 caratteri per la maggior parte degli account, utilizzando un mix di maiuscole, minuscole, numeri e simboli. Questo fornisce oltre 100 bit di entropia, ben al di là della portata della forza bruta. Per account particolarmente sensibili (email, banking, il tuo password manager stesso), vai a 20 o più.`)
};

const pt_br2_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelo menos 16 caracteres para a maioria das contas, usando uma mistura de maiúsculas, minúsculas, números e símbolos. Isso fornece mais de 100 bits de entropia, bem além do alcance de força bruta. Para contas especialmente sensíveis (email, banco, seu gerenciador de senhas), use 20 ou mais.`)
};

const pt_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelo menos 16 caracteres para a maioria das contas, utilizando uma mistura de maiúsculas, minúsculas, números e símbolos. Isso dá mais de 100 bits de entropia, bem para além do alcance de força bruta. Para contas especialmente sensíveis (e-mail, banca, o seu próprio gestor de senhas), use 20 ou mais.`)
};

const ja_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほとんどのアカウントについては最低16文字で、大文字、小文字、数字、記号を混ぜてください。これで100ビット以上のエントロピーが得られ、ブルートフォース攻撃の範囲をはるかに超えています。特に機密性の高いアカウント(メール、銀行、パスワードマネージャー自体)については、20文字以上にしてください。`)
};

const zh_pw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对大多数账户来说，至少应有 16 个字符，并混合使用大写字母、小写字母、数字和符号。这样可以获得超过 100 位的熵，远超暴力破解的能力范围。对于特别敏感的账户（电子邮件、银行账户、你的密码管理器本身），建议使用 20 位或更多。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_faq3_a", locale)
	if (locale === "en") return en_pw_faq3_a(inputs)
	if (locale === "es") return es_pw_faq3_a(inputs)
	if (locale === "de") return de_pw_faq3_a(inputs)
	if (locale === "nl") return nl_pw_faq3_a(inputs)
	if (locale === "fr") return fr_pw_faq3_a(inputs)
	if (locale === "it") return it_pw_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_pw_faq3_a(inputs)
	if (locale === "pt") return pt_pw_faq3_a(inputs)
	if (locale === "ja") return ja_pw_faq3_a(inputs)
	return zh_pw_faq3_a(inputs)
};